import React from "react"
import PointHistoryListTableComponent from "./pointHistoryListTable.component"

export default function PointHistoryListTableContainer({
  hasStockflowRewardCenterViewAccessRight,
  rows,
  isFetching,
  isError,
  handleReload,
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
  isSearchResult,
  totalFiltered,
  paginationOptions,
  tableFilter,
  changeOrder,
  lang,
  language,
  handleViewDetail
}) {
  return (
    <PointHistoryListTableComponent
      hasStockflowRewardCenterViewAccessRight={hasStockflowRewardCenterViewAccessRight}
      rows={rows}
      isFetching={isFetching}
      language={language}
      isError={isError}
      handleReload={handleReload}
      page={page}
      rowsPerPage={rowsPerPage}
      handleChangePage={handleChangePage}
      handleChangeRowPerPage={handleChangeRowsPerPage}
      isSearchResult={isSearchResult}
      totalFiltered={totalFiltered}
      paginationOptions={paginationOptions}
      tableFilter={tableFilter}
      changeOrder={changeOrder}
      lang={lang}
      handleViewDetail={handleViewDetail}
    />
  )
}